module.exports = __webpack_public_path__ + "static/media/slide-mobile (1).f07323eb.jpg";